export default __webpack_public_path__ + "static/1000008328-3a06c8b202aeb349d67d896defda887b.jpg";